// extracted by mini-css-extract-plugin
module.exports = {"saveLayoutWrapper":"SaveLayout_saveLayoutWrapper__Wjx__","saveLayoutFooter":"SaveLayout_saveLayoutFooter__XFXVw"};